export enum OffboardingStatus {
  Pending = "Pending",
  Accepted = "Accepted",
  Rejected = "Rejected",
}

export enum OffboardingInitiatedBy {
  Admin = "Admin",
  Employee = "Employee",
}

// Backend returns/accepts status strings with inconsistent casing, so all
// comparisons must go through this instead of raw equality.
export function isOffboardingStatus(value: string | null | undefined, status: OffboardingStatus): boolean {
  return value?.toLowerCase() === status.toLowerCase()
}

// Accepted and Rejected both lock further edits (mirrors the backend guard
// in UpdateEmployeeOffboardingCommandHandler). Accepted is a one-way door;
// Rejected can still be reset back to Pending by an admin.
export function isOffboardingTerminal(value: string | null | undefined): boolean {
  return isOffboardingStatus(value, OffboardingStatus.Accepted) || isOffboardingStatus(value, OffboardingStatus.Rejected)
}

export function isOffboardingResettable(value: string | null | undefined): boolean {
  return isOffboardingStatus(value, OffboardingStatus.Rejected)
}
